import React from "react";
import { useSelector, useDispatch } from "types/store";

import { Button, Icon } from "aible";
import moment from "moment";

import { getIsGoogleModel, MODELS } from "containers/ChatGPT/reducer";

import AWSModelIcon from "images/Model Icons/aws.svg";
import GoogleModelIcon from "images/logo-gcp.svg";
import LlamaModelIcon from "images/Model Icons/llama.svg";
import MistralModelIcon from "images/Model Icons/mistral-logo.svg";
import OpenAIModelIcon from "images/Model Icons/openai 1.svg";

import checkCircleIcon from "images/Next-Icons/TaskIcon.svg";
import DownloadsGrayIcon from "images/downloads-gray.svg";

import * as MarketReducer from "containers/CommunityMarket/MarketReducer";

import styles from "./style.module.css";

const MarketItemCard = (props) => {
  const { name, price, metadata, type, created_date, created_by, source, id } = props;

  const dispatch = useDispatch();

  const cartItemsArray = useSelector((state) => MarketReducer.getCartItemsArray(state));
  const addToCart = (itemId) => dispatch(MarketReducer.addToCart(itemId));
  const removeFromCart = (itemId) => dispatch(MarketReducer.removeFromCart(itemId));
  const itemInCart = cartItemsArray?.includes(id);
  const isCartOpen = useSelector((state) => MarketReducer.getIsCartOpen(state));
  const updateIsCartOpen = (bool) => dispatch(MarketReducer.updateIsCartOpen(bool));

  const getLogoIcon = (llmType) => {
    if (getIsGoogleModel(llmType)) {
      return GoogleModelIcon;
    }
    if (llmType === MODELS.CHAT_GPT || llmType === "gpt-3.5-turbo") {
      return OpenAIModelIcon;
    }
    if (llmType === "mistral") {
      return MistralModelIcon;
    }
    if (llmType === MODELS.MISTRAL) {
      return LlamaModelIcon;
    }
    if (llmType === MODELS.TITAN) {
      return AWSModelIcon;
    }
    return undefined;
  };

  const feedbackCount = (metadata?.like_count ?? 0) + (metadata?.dislike_count ?? 0);
  const downloadCount = metadata?.downloads ?? 0;
  const retPrice = price > 0 ? `$${price}` : "FREE";

  return (
    <div className={styles.marketItemCardWrapper}>
      <div className={styles.marketItemCardHeader}>
        {type === "FINE_TUNED_MODEL" && (
          <div className={styles.marketCardLogoWrapper}>
            <img className={styles.marketCardLogo} src={getLogoIcon(metadata?.base_model)} />
          </div>
        )}
        <div className={styles.marketItemCardTitle}>{name}</div>
      </div>
      <div className={styles.marketItemCardBody}>
        <div className={styles.marketItemCardBodyHeader}>
          <div className={styles.marketItemCategory}>{metadata?.use_case ?? "Uncategorized"}</div>
          <div className={styles.marketItemFeedback}>
            <Icon type="thumbsUpPurple" size={16} style={{ marginRight: "4px" }} />
            {feedbackCount}
          </div>
        </div>
        <div className={styles.marketItemSummary}>{metadata?.summary ?? "This is a placeholder"}</div>
        <div className={styles.marketItemBodyFooter}>
          <div className={styles.marketItemCardBodyFeedbackDetail} style={{ marginRight: "20px" }}>
            <div className={styles.marketDownloadsIconWrapper}>
              <img src={DownloadsGrayIcon} />
            </div>
            <div className={styles.marketDownloadText}>{downloadCount}</div>
          </div>
          <div className={styles.marketItemCardBodyFooterDetail}>
            <span className={styles.detailLight}>{`Updated ${moment.utc(created_date).fromNow()} by `}</span>
            <span className={styles.detailDark}>{`${created_by?.fullname}`}</span>
          </div>
        </div>
      </div>
      <div className={styles.marketItemCardFooter}>
        <div className={styles.marketFooterActionsWrapper}>
          <div className={styles.marketItemCardPrice}>{retPrice}</div>
          <Button
            onClick={() => {
              if (!itemInCart) {
                addToCart(id);
                if (isCartOpen !== true) {
                  updateIsCartOpen(true);
                }
              }
            }}
            style={
              itemInCart
                ? {
                    backgroundColor: "#DDD5FF",
                    borderColor: "#8556EB"
                  }
                : {}
            }
          >
            {itemInCart ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={checkCircleIcon} style={{ width: "20px", marginRight: "10px" }} />
                {"In Cart"}
              </div>
            ) : (
              "Add to Cart"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MarketItemCard;
